export const enum MediaType {
	OctetStream = 'application/octet-stream',
	OctetStream2 = 'binary/octet-stream',

	Html = 'text/html',
	Xhtml = 'application/xhtml+xml',
	Css = 'text/css',

	Woff = 'font/woff',
	Woff2 = 'font/woff2',
	Ttf = 'font/ttf',

	Png = 'image/png',
	GIF = 'image/gif',
	JPEG = 'image/jpeg',
	Svg = 'image/svg+xml',
	Tiff = 'image/tiff',

	Ico = 'image/vnd.microsoft.icon',
	Pcx = 'image/vnd.zbrush.pcx',
	Dcx = 'image/x-dcx',
	Thumbsdb = 'application/vnd.microsoft.windows.thumbnail-cache',

	Bmp = 'image/bmp',
	Dib = 'image/x-dib',

	Emf = 'image/emf',
	Emz = 'image/emz',
	Wmf = 'image/wmf',
	Wmz = 'image/wmz',

	Zip = 'application/zip',

	MsWord = 'application/msword',
	MsWordDocOoxml = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
	MsWordTemplate = 'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
	MsWordDocMacroEnabled = 'application/vnd.ms-word.document.macroEnabled.12',
	MsWordTemplateMacroEnabled = 'application/vnd.ms-word.template.macroEnabled.12',
	Rtf = 'application/rtf',
	Rtfd = 'application/x-rtfd',

	Pdf = 'application/pdf',
	PdfPortfolio = 'application/x-pdf-portfolio',

	EML = 'message/rfc822',
	EMLX = 'message/x-emlx',
	MSG = 'application/vnd.ms-outlook',

	PST = 'application/vnd.ms-outlook-pst',
	MHTML = 'application/x-mimearchive',
	DXF = 'image/vnd.dxf',
	DWG = 'image/vnd.dwg',
	OLM = 'application/olm',
	Json = 'application/json',

	OLM_EMAIL = 'application/x.ms-outlook-olm-email+xml',
	OLM_APPOINTMENT = 'application/x.ms-outlook-olm-appointment+xml',
	OLM_CONTACT = 'application/x.ms-outlook-olm-contact+xml',
	OLM_NOTE = 'application/x.ms-outlook-olm-note+xml',
	OLM_TASK = 'application/x.ms-outlook-olm-task+xml',

	TGA = 'image/x-tga',

	STEP = 'application/step',
	IGES = 'application/iges',
	PARASOLID_XT = 'model/vnd.parasolid.transmit.text',
	PARASOLID_XB = 'model/vnd.parasolid.transmit.binary',

	ICS = 'text/calendar',
	VCF = 'text/vcard',

	Js = 'text/javascript',

	Xml = 'application/xml',
	Thmx = 'application/vnd.ms-officetheme',

	Pages = 'application/vnd.apple.pages',
	Pages13 = 'application/vnd.apple.pages.13',
	Pages18 = 'application/vnd.apple.pages.18',

	Numbers = 'application/vnd.apple.numbers',
	Numbers13 = 'application/vnd.apple.numbers.13',
	Numbers18 = 'application/vnd.apple.numbers.18',

	Keynote = 'application/vnd.apple.keynote',
	Keynote13 = 'application/vnd.apple.keynote.13',
	Keynote18 = 'application/vnd.apple.keynote.18',

	BinHex = 'application/mac-binhex40',
	MacBinary = 'application/macbinary',
	MacBinaryX = 'application/x-macbinary',
	AppleSingle = 'application/applefile',
	AppleDouble = 'multipart/appledouble',

	Bplist = 'application/x-bplist',

	Webarchive = 'application/x-webarchive',
	IChat = 'application/x-ichat',

	Ole1 = 'application/x-ms-ole1',
	Ole2 = 'application/x-ms-ole2',

	WordPerfect = 'application/vnd.wordperfect',

	CSV = 'text/csv',
	TSV = 'text/tab-separated-values',
	JBIG2 = 'image/x-jbig2',

	DBF = 'application/x-dbf',

	Visio = 'application/vnd.visio',
	SpreadsheetMl = 'application/vnd.ms-spreadsheetml',

	// From Tika, see http://justsolve.archiveteam.org/wiki/WordProcessingML
	WordDocXml2003 = 'application/vnd.ms-wordml',
	// From Tika, see http://justsolve.archiveteam.org/wiki/WordProcessingML
	WordDocXml2006 = 'application/vnd.ms-word2006ml',
	// Custom
	PowerPointPres2006 = 'application/x-vnd.ms-presentation2006ml',

	ZipSpanSegment = 'application/x-zip-span-segment',
	ZipSpanSegmentFinal = 'application/x-zip-span-segment-final',

	ZipSplitSegment = 'application/x-zip-split-segment',
	ZipSplitSegmentFinal = 'application/x-zip-split-segment-final',

	OneNote = 'application/msonenote',

	Ichitaro = 'application/x-js-taro',

	PowerPointCfb = 'application/vnd.ms-powerpoint',
	Publisher = 'application/x-mspublisher',

	PGPKey = 'application/pgp-keys',

	PlainText = 'text/plain',

	WebP = 'image/webp',

	PostScript = 'application/postscript',

	EPS_APP_X = 'application/x-eps',
	EPS_APP = 'application/eps',
	EPS_IMG_X = 'image/x-eps',
	EPS_IMG = 'image/eps',

	ILLUSTRATOR_PS = 'application/x-illustrator-ps',

	// Used by Tika
	ILLUSTRATOR_PDF_TIKA = 'application/illustrator',

	PTX = 'application/x-etranscript',
	PTXSecure = 'application/x-etranscript-secure',

	EXE = 'application/vnd.microsoft.portable-executable',

	HEIC = 'image/heic',

	// AUDIO
	Opus = 'audio/ogg',
	AAC = 'audio/aac',
	M4A = 'audio/m4a',
	AMR = 'audio/amr',

	// VIDEO
	MP4 = 'video/mp4',
	MOV = 'video/quicktime',
	'3GP' = 'video/3gpp',

	// OpenDocument Text
	ODT = 'application/vnd.oasis.opendocument.text',
	// From Tika
	FODT = 'application/vnd.oasis.opendocument.flat.text',
	OTT = 'application/vnd.oasis.opendocument.text-template',

	// OpenDocument Presentation
	ODP = 'application/vnd.oasis.opendocument.presentation',
	// From Tika
	FODP = 'application/vnd.oasis.opendocument.flat.presentation',
	OTP = 'application/vnd.oasis.opendocument.presentation-template',

	// OpenDocument Spreadsheet
	ODS = 'application/vnd.oasis.opendocument.spreadsheet',
	// From Tika
	FODS = 'application/vnd.oasis.opendocument.flat.spreadsheet',
	OTS = 'application/vnd.oasis.opendocument.spreadsheet-template',
}
